<div class="modal-content">
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="modal-header">

  <h3 class="modal-title font">Subir consentimiento firmado</h3>

    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <form class="form-search py-3" [formGroup]="formGroup">

      <div class="row-fields">

      <div class="field field-100">
        <label for="fechaFirma">Fecha firma del consentimiento <span class="oblig">*</span></label>
        <mat-form-field appearance="outline">
          <input matInput [matDatepicker]="datepickerFechaFirma" formControlName="fechaFirma">
          <mat-datepicker-toggle matIconSuffix [for]="datepickerFechaFirma"></mat-datepicker-toggle>
          <mat-datepicker #datepickerFechaFirma>
          </mat-datepicker>
          <mat-error *ngIf="controlHasError('fechaFirma', 'matDatepickerParse')">Formato incorrecto
          </mat-error>
          <mat-error *ngIf="controlHasError('fechaFirma', 'required')">Campo obligatorio</mat-error>
          <mat-error *ngIf="controlHasError('fechaFirma', 'fechaNoPosterior')">La fecha no debe ser posterior a hoy</mat-error>
        </mat-form-field>
        </div>
      </div>
     <div class="attach">
        <div>
          <button mat-button aria-labe="Adjuntar archivo" class="adjuntar-btn" type="button" (click)="file.click()"
            [disabled]="adjuntosBlob!.length>0">
            Adjuntar archivo
          </button>
          <label class="sr-only" for="adjuntar">Adjuntar archivo </label>
          <input #file type="file" (change)="file && file.files && attachAdjunto(file.files[0])" class="hide"
            id="adjuntar" name="adjuntar">
        </div>
        <div>
          <div fxLayout="row" fxLayoutAlign="space-between center" *ngFor="let archivo of adjuntosBlob"
            class="centrar archivo">
            <div><span class="sprite-icon ico-adjuntar"></span><span class="nombre-archivo">{{archivo?.name}}
              </span>
            </div>
          </div>
        </div>
      </div>

    </form>

  </div>
  <div class="modal-footer actions">
    <div class="note"><span>* Campos Obligatorios</span></div>
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
        aria-label="Cancelar">Cancelar</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="guardar()"
        aria-label="Guardar">Guardar</button>
    </div>
  </div>
  </div>
